import routes, { castRoutes, summaryRoutes } from '../../routes';

export const getFrontRoutesFromLocation = () => {
    const { pathname } = window.location;
    if (pathname.startsWith('/cast/')) return castRoutes;
    if (pathname.startsWith('/summary')) return summaryRoutes;
    return routes;
};
